import { Outlet } from 'react-router-dom';
import { TestId } from '@repo/test-id';

import { SplashScreenOverlay } from '@features/splashScreen';
import { AuthOverlay, ImpersonationBanner } from '@features/auth';

export default function Layout() {
  const splashScreenTestId = TestId.root('splashScreen');

  return (
    <div className="flex h-full w-full flex-col">
      <SplashScreenOverlay testId={splashScreenTestId} />
      <div className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </div>
      <AuthOverlay />
      <ImpersonationBanner />
    </div>
  );
}
